<template>
  <div>
    <img
      v-if="profilePic"
      alt="Profile Picture"
      :class="imageClass"
      :src="profilePic"
      :style="{
        'max-width': width,
        'max-height': height,
      }"
    />
    <div v-if="!profilePic" :class="imageClass" class="default-picture-container">
      <font-awesome-icon :icon="['fas', 'user-circle']" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserProfileImage',
  props: {
    profilePic: {
      default: '',
      validator: prop => typeof prop === 'string' || prop === null,
    },
    imageClass: {
      type: String,
      default: 'box__maker-profile-picture',
    },
    width: {
      type: String,
      default: '140px',
    },
    height: {
      type: String,
      default: '140px',
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../styles/layout';

.default-picture-container {
  margin-left: auto;
  margin-right: auto;

  display: flex;
  align-items: center;
  justify-content: center;

  color: $primary;

  svg {
    height: 80%;
    width: 80%;
    background-color: white;
    border-radius: 50%;
  }
}

.user-photo {
  margin: -75px 0 1.25rem;
  border-radius: 50%;
  border: 50px;
  object-fit: cover;
}
</style>
